import { TreeItemButton, treeItem } from '@air/component-tree';
import { CheckIcon, ImageSearchLegacyIcon } from '@air/design-icons';

export type BoardSelectAllAssetsAndFilesListItemProps = {
  isSelected?: boolean;
  onSelect: () => void;
};

export const BoardSelectAllAssetsAndFilesListItem = ({
  isSelected,
  onSelect,
}: BoardSelectAllAssetsAndFilesListItemProps) => {
  return (
    <div className={treeItem({ size: 'small', state: isSelected ? 'selected' : 'default' })}>
      <ImageSearchLegacyIcon size="sm" className="shrink-0" />

      <TreeItemButton data-testid="BOARD_SELECT_ALL_ASSETS_AND_FILES" onClick={onSelect}>
        All assets & files
      </TreeItemButton>

      {isSelected && (
        <div className="flex size-4 shrink-0 items-center justify-center rounded-full ads:bg-primary-subtle bg-blue-3">
          <CheckIcon size="xs" className="ads:text-icon-primary text-blue-11" />
        </div>
      )}
    </div>
  );
};
